import { atom, useAtomValue, useSetAtom } from 'jotai';

interface SidebarPanelOverride {
  /** The rail item whose submenu panel to show (e.g. `community`). */
  itemId: string;
  /** The page it was opened on — the override only holds while the user stays there. */
  pathname: string;
  /** Bumped on every open, so re-clicking the rail item re-expands every folder. */
  openedAt: number;
}

/**
 * A rail item that opens its submenu panel without navigating (Community):
 * normally the panel is derived from the route, so this pins it to the clicked
 * item until the user moves to another page. Not persisted — a reload goes back
 * to the route-derived panel.
 */
const sidebarPanelOverrideAtom = atom<SidebarPanelOverride | null>(null);

export const useSidebarPanelOverride = () => useAtomValue(sidebarPanelOverrideAtom);

export const useOpenSidebarPanel = () => {
  const setOverride = useSetAtom(sidebarPanelOverrideAtom);
  return (itemId: string, pathname: string) => setOverride({ itemId, pathname, openedAt: Date.now() });
};

/**
 * Hand the panel back to the route. Needed when a rail item navigates: going to
 * the page you are already on (Programs while on /programs) keeps the pathname,
 * so the override would otherwise keep showing the previous panel.
 */
export const useClearSidebarPanel = () => {
  const setOverride = useSetAtom(sidebarPanelOverrideAtom);
  return () => setOverride(null);
};
